const nanoid = require('nanoid')
const generate = require('nanoid/generate')

// strategies should return a nano id
const lengthStrategy = ({ length }) => () => nanoid(length)
const customAlphabetStrategy = ({ alphabet, length }) => () => generate(alphabet, length)
const defaultStrategy = () => () => nanoid()

const alphabetValid = (alphabet) => alphabet !== undefined && typeof alphabet === 'string'
const lengthValid = (length) => length !== undefined && typeof length === 'number'

export default function * idGen (seed = 0) {
  let id = seed
  while (true) {
    let reset = yield id++
    if (reset) {
      id = seed - 1
    }
  }
}

export function * randomIdGen (config = {}) {
  const { length, alphabet } = config
  let strategy = defaultStrategy()
  if (alphabetValid(alphabet) && lengthValid(length)) {
    strategy = customAlphabetStrategy({ alphabet, length })
  } else if (lengthValid(length)) {
    strategy = lengthStrategy({ length })
  }
  while (true) {
    const id = strategy()
    yield id
  }
}
